var animationDurationInMS;

(function (animationDurationInMS) {
  animationDurationInMS[animationDurationInMS["slower"] = 500] = "slower";
  animationDurationInMS[animationDurationInMS["slow"] = 400] = "slow";
  animationDurationInMS[animationDurationInMS["medium"] = 300] = "medium";
  animationDurationInMS[animationDurationInMS["fast"] = 250] = "fast";
  animationDurationInMS[animationDurationInMS["faster"] = 200] = "faster";
  animationDurationInMS[animationDurationInMS["fastest"] = 150] = "fastest";
})(animationDurationInMS || (animationDurationInMS = {}));

export default animationDurationInMS;